import React, { useState } from 'react';
import './style.css'
import NavBar from '../../components/NavBar';
import CabecalhoCadastros from '../../components/CabecalhoCadastros';
import FormColaborador from '../../components/Form/FormColaborador';
import FormMaquina from '../../components/Form/FormMaquina';
import FormularioComprador from '../../components/Form/FormComprador';
import useFetchMaquinas from '../../hooks/maquina/useFetchMaquinas';
import CardMaquina from '../../components/Cards/CardMaquina';
import useDeleteMaquina from '../../hooks/maquina/useDeleteMaquina';
import useFetchColaboradores from '../../hooks/colaborador/useFetchColaboradores';
import useDeleteColaborador from '../../hooks/colaborador/useDeleteColaborador';
import CardColaborador from '../../components/Cards/CardColaborador/CardColaborador';


type FormularioSelecionado = 'colaborador' | 'maquina' | 'comprador' | null;

export default function Cadastro() {
  const { maquinas, refetchMaquinas } = useFetchMaquinas();
  const { handleDeleteMaquina } = useDeleteMaquina();
  const { colaboradores, refetchColaboradores } = useFetchColaboradores();
  const { handleDeleteColaborador } = useDeleteColaborador();

  const [formularioSelecionado, setFormularioSelecionado] = useState<FormularioSelecionado>(null);

  const mostrarFormulario = (formulario: FormularioSelecionado) => {
    setFormularioSelecionado(formulario);
  };

  return (
    <main>
      <NavBar />
      <div className="container-cadastros">
        <CabecalhoCadastros mostrarFormulario={mostrarFormulario} />

        {formularioSelecionado === 'colaborador' &&
          <div>
            <FormColaborador />
            {
              colaboradores.map((colaborador) => (
                <CardColaborador
                  key={colaborador.id}
                  colaborador={colaborador}
                  onClick={() => ''}
                  excluir={(id) => {
                    handleDeleteColaborador(id).then(() => refetchColaboradores())
                  }}
                />
              ))
            }
          </div>
        }

        {formularioSelecionado === 'maquina' &&
          <div className='alinharVertical'>
            <FormMaquina />
            {
              maquinas.map((maquina) => (
                <CardMaquina
                  key={maquina.id}
                  maquina={maquina}
                  onClick={() => ''}
                  excluir={(id) => {
                    handleDeleteMaquina(id).then(() => refetchMaquinas());
                  }}
                />
              ))
            }
          </div>
        }

        {formularioSelecionado === 'comprador' && <FormularioComprador />}
      </div>
    </main>
  );
}
